import { en } from './en';
import { ru } from './ru';
import { es } from './es';
import { fr } from './fr';
import { de } from './de';
import { it } from './it';
import { pt } from './pt';
import { pl } from './pl';
import { zh } from './zh';
import { ja } from './ja';
import { ko } from './ko';
import { ar } from './ar';
import { bg } from './bg';
import { hr } from './hr';
import { cs } from './cs';
import { da } from './da';
import { nl } from './nl';
import { et } from './et';
import { fi } from './fi';
import { el } from './el';
import { hu } from './hu';
import { ga } from './ga';
import { lv } from './lv';
import { lt } from './lt';
import { mt } from './mt';
import { ro } from './ro';
import { sk } from './sk';
import { sl } from './sl';
import { sv } from './sv';

export const translations = {
  en,
  ru,
  es,
  fr,
  de,
  it,
  pt,
  pl,
  zh,
  ja,
  ko,
  ar,
  bg,
  hr,
  cs,
  da,
  nl,
  et,
  fi,
  el,
  hu,
  ga,
  lv,
  lt,
  mt,
  ro,
  sk,
  sl,
  sv
};

export type SupportedLanguage = keyof typeof translations;
export type TranslationKeys = typeof en;

export const defaultLanguage: SupportedLanguage = 'en';
